'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.serverItemsToProGallery = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapResolutionsToWixVideoQualities = function mapResolutionsToWixVideoQualities(resolutions) {
  return resolutions.map(function (resolution) {
    return {
      formats: [(0, _keys2.default)(resolution.urls)[0]],
      height: resolution.height,
      quality: resolution.videoMode || resolution.height + 'p',
      width: resolution.width
    };
  });
};

var createPhotoUrl = function createPhotoUrl(serverMediaUrl) {
  var mediaUrlStartIndex = serverMediaUrl.lastIndexOf('/');
  return serverMediaUrl.substring(mediaUrlStartIndex + 1);
};

var getLastUrlPath = function getLastUrlPath(url) {
  var splittedUrl = url.split('/');
  if (splittedUrl && splittedUrl.length > 0) {
    return splittedUrl.pop();
  }
  return '';
};
var getWixMediaUrlVideo = function getWixMediaUrlVideo(serverMediaUrl) {
  var serverMediaUrlSplit = serverMediaUrl.split('video.wixstatic.com/video/');
  if (serverMediaUrlSplit && serverMediaUrlSplit.length === 2) {
    var serverMediaUrlSlashSplit = serverMediaUrlSplit.pop().split('/');
    if (serverMediaUrlSlashSplit.length > 0) {
      return serverMediaUrlSlashSplit[0];
    }
  }
  return '';
};

var mapProGalleryVideoPosters = function mapProGalleryVideoPosters(serverPosters, isCustomPoster) {
  return serverPosters.filter(function (poster) {
    if (!isCustomPoster && (!('default' in poster) || !poster.default)) {
      return true;
    }if (isCustomPoster && ('default' in poster || !!poster.default)) {
      return true;
    }
    return false;
  }).map(function (poster) {
    return {
      height: poster.height,
      width: poster.width,
      url: getLastUrlPath(poster.url)
    };
  });
};

var generateProGalleryLink = function generateProGalleryLink(serverLink) {
  var serverLinkFieldOptions = [{ serverLinkField: 'phone', type: 'PhoneLink' }, { serverLinkField: 'email', type: 'EmailLink' }, { serverLinkField: 'document', type: 'DocumentLink' }, { serverLinkField: 'page', type: 'PageLink' }, { serverLinkField: 'external', type: 'ExternalLink' }, { serverLinkField: 'anchor', type: 'AnchorLink' }, { serverLinkField: 'dynamicPage', type: 'DynamicPage' }];
  var proGalleryserverLink = serverLinkFieldOptions.find(function (_ref) {
    var serverLinkField = _ref.serverLinkField;
    return serverLink.wixLinkData && serverLink.wixLinkData['' + serverLinkField];
  });
  return (0, _extends3.default)({
    target: serverLink.target,
    type: 'wix',
    data: (0, _extends3.default)({}, serverLink.wixLinkData['' + proGalleryserverLink.serverLinkField], {
      type: proGalleryserverLink.type
      // ...('url' in serverLink && {url: serverLink.url}) -- now we get wixPage direct url add this in future if needed
    })
  }, 'text' in serverLink && { text: serverLink.text });
};

var buildVideo = function buildVideo(proGalleryItem, serverItem) {
  var videoData = serverItem.videoMetadata;
  var isExternalVideo = 'source' in videoData && videoData.source !== 'Undefined';
  proGalleryItem = (0, _extends3.default)({}, proGalleryItem, isExternalVideo && 'posters' in videoData && videoData.posters.length > 0 && { mediaUrl: getLastUrlPath(videoData.posters[0].url) }, !isExternalVideo && 'mediaUrl' in serverItem && { mediaUrl: getWixMediaUrlVideo(serverItem.mediaUrl) });
  proGalleryItem.metaData = (0, _extends3.default)({}, proGalleryItem.metaData, {
    type: 'video'
  }, 'posters' in videoData && { customPoster: mapProGalleryVideoPosters(videoData.posters, true).length > 0 ? mapProGalleryVideoPosters(videoData.posters, true)[0] : '' }, 'source' in videoData && { isExternal: isExternalVideo }, 'height' in videoData && { height: videoData.height }, 'width' in videoData && { width: videoData.width }, 'name' in serverItem && { name: serverItem.name }, 'posters' in videoData && { posters: mapProGalleryVideoPosters(videoData.posters, false) }, !isExternalVideo && 'resolutions' in videoData && { qualities: mapResolutionsToWixVideoQualities(videoData.resolutions) }, isExternalVideo && { qualities: [] }, 'duration' in videoData && { duration: Number(videoData.duration) }, isExternalVideo && { source: videoData.source.toLowerCase() }, isExternalVideo && { videoUrl: serverItem.mediaUrl }, isExternalVideo && { videoId: videoData.externalId }, 'posters' in videoData && 'focalPoint' in videoData.posters[0] && { focalPoint: [videoData.posters[0].focalPoint.x, videoData.posters[0].focalPoint.y] });
  return proGalleryItem;
};

var photoGalleryQuality = function photoGalleryQuality(photoData) {
  var shouldAddPhotoQuality = 'quality' in photoData || 'unsharpMasking' in photoData;
  return (0, _extends3.default)({}, shouldAddPhotoQuality && { sharpParams: { L: (0, _extends3.default)({}, 'quality' in photoData && { overrideQuality: true, quality: photoData.quality }, 'unsharpMasking' in photoData && { overrideUsm: true, usm: (0, _extends3.default)({}, 'amount' in photoData.unsharpMasking && { usm_a: photoData.unsharpMasking.amount }, 'radius' in photoData.unsharpMasking && { usm_r: photoData.unsharpMasking.radius }, 'threshold' in photoData.unsharpMasking && { usm_t: photoData.unsharpMasking.threshold }) }) } });
};

var buildPhoto = function buildPhoto(proGalleryItem, serverItem) {
  var haveMediaUrl = 'mediaUrl' in serverItem && createPhotoUrl(serverItem.mediaUrl);
  proGalleryItem = (0, _extends3.default)({}, proGalleryItem, haveMediaUrl && { mediaUrl: createPhotoUrl(serverItem.mediaUrl) });
  var photoData = serverItem.photoMetadata;
  proGalleryItem.metaData = (0, _extends3.default)({}, proGalleryItem.metaData, {
    sourceName: 'private'
  }, 'tags' in serverItem && { tags: serverItem.tags }, 'sourceName' in photoData && { isDemo: serverItem.sourceName === 'private' }, 'height' in photoData && { height: photoData.height }, 'width' in photoData && { width: photoData.width }, 'focalPoint' in photoData && { focalPoint: [photoData.focalPoint.x, photoData.focalPoint.y] }, 'name' in serverItem && { fileName: serverItem.name }, haveMediaUrl && { name: createPhotoUrl(serverItem.mediaUrl) }, photoGalleryQuality(photoData));
  return proGalleryItem;
};

var buildText = function buildText(proGalleryItem, serverItem) {
  var textData = serverItem.textMetadata;
  var textDataHaveStyle = 'style' in textData;
  proGalleryItem = (0, _extends3.default)({}, proGalleryItem, {
    mediaUrl: ''
  });

  proGalleryItem.metaData = (0, _extends3.default)({}, proGalleryItem.metaData, {
    type: 'text'
  }, 'editorHtml' in textData && { editorHtml: textData.editorHtml }, 'html' in textData && { html: textData.html }, 'name' in serverItem && { name: serverItem.name }, 'fontPickerStyleParamName' in textData && { fontPickerStyleParamName: textData.fontPickerStyleParamName }, textDataHaveStyle && 'height' in textData.style && { height: textData.style.height }, textDataHaveStyle && 'width' in textData.style && { width: textData.style.width }, textDataHaveStyle && { textStyle: textData.style }, 'editorFontId' in textData && { fontPickerStyleParamName: textData.editorFontId });
  return proGalleryItem;
};

var serverItemsToProGallery = function serverItemsToProGallery(serverItems) {
  try {
    var proGalleryItems = serverItems.map(function (serverItem) {
      var proGalleryItem = (0, _extends3.default)({}, 'id' in serverItem && { itemId: serverItem.id }, 'isSecure' in serverItem && { secure: serverItem.isSecure }, 'orderIndex' in serverItem && { orderIndex: serverItem.orderIndex }, {
        metaData: (0, _extends3.default)({}, 'description' in serverItem && { description: serverItem.description }, 'title' in serverItem && { title: serverItem.title }, {
          link: {
            type: 'none',
            target: '_blank'
          }
        }, 'link' in serverItem && { link: generateProGalleryLink(serverItem.link) })
      });
      if (serverItem.dataType === 'Video') {
        return buildVideo(proGalleryItem, serverItem);
      } else if (serverItem.dataType === 'Photo') {
        return buildPhoto(proGalleryItem, serverItem);
      } else if (serverItem.dataType === 'Text') {
        return buildText(proGalleryItem, serverItem);
      }
      return {};
    });
    return proGalleryItems;
  } catch (e) {
    console.error('Wrong format for gallery items', serverItems, e);
    return [];
  }
};

exports.serverItemsToProGallery = serverItemsToProGallery;